/**
 * Does this client's therapy_type mean the teen flow.
 *
 * Trims AND lowercases, because the backend compares the same way. A stored
 * name with incidental whitespace or casing (`"Teen "`, `"teen"`) must classify
 * the same way here as it does server-side, or a teen silently falls through to
 * the adult path — and the failure is invisible, because the affected UI simply
 * never renders.
 *
 * The app and the backend each hold their own copy of this rule and nothing
 * enforces that the three agree, so a change here is a change in all of them.
 *
 * Hub still has many inline `therapy_type?.name === 'Teen'` comparisons that
 * predate this helper; migrate them to this function rather than adding more.
 */
export function isTeenTherapyType(therapyTypeName?: string | null): boolean {
   return (therapyTypeName ?? '').trim().toLowerCase() === 'teen';
}
